<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>

        </div>

       <div class="content" v-else>

               <h1 v-if="type === 'add'">
                    Vytváření vydavatele
               </h1>
               <h1 v-else>
                    Detail vydavatele
               </h1>


           <v-layout>
               <table class="info-table">
                   <tr>
                       <td class="info-table__title">
                           Vyúčtování:
                       </td>
                       <td class="info-table__value">
                           <v-btn
                                   color="secondary"
                                   type="submit"
                                   class="button--control"
                                   @click="showBilling()"
                            >
                               Zobrazit
                           </v-btn>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Prodeje:
                       </td>
                       <td class="info-table__value">
                           <v-btn
                                   color="secondary"
                                   type="submit"
                                   class="button--control"
                                   @click="showSales()"
                           >
                               Zobrazit
                           </v-btn>
                       </td>
                   </tr>
                  <!-- <tr>
                       <td class="info-table__title">
                           Import prodejů:
                       </td>
                       <td class="info-table__value">
                           <v-btn
                                   color="secondary"
                                   type="submit"
                                   class="button&#45;&#45;control"
                                   @click="importSales()"
                           >
                               Importovat
                           </v-btn>
                       </td>
                   </tr>-->
                   <tr>
                       <td class="info-table__title">
                           Náhledový obrázek:
                       </td>
                       <td class="info-table__value">


                           <div v-if="!imageUploaded">
                               <div class="image image--loader">
                                   <div class="loader">
                                       <div class="loader__item">
                                       </div>
                                       <div class="loader__text">Nahrávání</div>
                                   </div>
                               </div>
                           </div>
                           <div v-else>
                               <div class="image image--data" v-if="data.image" :style="'background-image:url('+data.image+')'">
                               </div>
                               <div class="image image--empty" v-else>
                               </div>
                           </div>



                           <div class="image-controls"  v-if="imageUploaded ">
                               <v-btn
                                       @click="selectCoverImage()"
                                       v-if="!data.image"
                                       color="primary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat
                               </v-btn>

                               <v-btn
                                       @click="selectCoverImage()"
                                       v-if="data.image"
                                       color="secondary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat jiný
                               </v-btn>
                               <v-btn
                                       @click="removeCoverImage()"
                                       v-if="data.image"
                                       color="error"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Smazat
                               </v-btn>
                           </div>
                       </td>
                   </tr>
	               <tr >
		               <td class="info-table__title">
			               Alt:
		               </td>
		               <td class="info-table__value">
			               <v-text-field

				                class="input--larger"
				                outlined
				                @input="errors.image_alt = ''"
				                v-model="data.image_alt"
				                :error-messages="makeError(errors.image_alt)"
			               >
			               </v-text-field>
		               </td>
	               </tr>
                   <tr v-if="type !== 'add'">
                       <td class="info-table__title">
                           ID:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   disabled
                                   class="input--small"
                                   outlined
                                   @input="errors.id = ''"
                                   v-model="data.id"
                                   :error-messages="makeError(errors.id)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Jméno: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   @input="errors.forename = ''"
                                   v-model="data.forename"
                                   :error-messages="makeError(errors.forename)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Příjmení:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.surname"
                                   @input="errors.surname = ''"
                                   :error-messages="makeError(errors.surname)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           E-mail:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.email"
                                   @input="errors.email = ''"
                                   :error-messages="makeError(errors.email)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Majitel licence:
                       </td>
                       <td class="info-table__value">
                           <v-checkbox
                                   class="input--small"
                                   outlined
                                   v-model="data.licence"
                                   @input="errors.licence = ''"
                                   :error-messages="makeError(errors.licence)"
                           >
                           </v-checkbox>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Ulice:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.street"
                           >
                           </v-text-field>
                       </td>
                   </tr>

                   <tr>
                       <td class="info-table__title">
                           Č.p.:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.no"
                           >
                           </v-text-field>
                       </td>
                   </tr>

                   <tr>
                       <td class="info-table__title">
                           Město:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.city"
                           >
                           </v-text-field>
                       </td>
                   </tr>


                   <tr>
                       <td class="info-table__title">
                           PSČ:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.zip"
                           >
                           </v-text-field>
                       </td>
                   </tr>


                   <tr>
                       <td class="info-table__title">
                           Telefon:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.tel"
                           >
                           </v-text-field>
                       </td>
                   </tr>


                   <tr>
                       <td class="info-table__title">
                           IČ:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.ico"
                           >
                           </v-text-field>
                       </td>
                   </tr>


                   <tr>
                       <td class="info-table__title">
                           DIČ:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.dic"
                           >
                           </v-text-field>
                       </td>
                   </tr>


                   <tr>
                       <td class="info-table__title">
                           Společnost:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.company"
                           >
                           </v-text-field>
                       </td>
                   </tr>

                   <tr>
                       <td class="info-table__title">
                           Slug: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.slug"
                                   @input="errors.slug = ''"
                                   :error-messages="makeError(errors.slug)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Popis: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-textarea
                                   class="input--larger"
                                   outlined
                                   @input="errors.description = ''"
                                   v-model="data.description"
                                   :error-messages="makeError(errors.description)"
                           >
                           </v-textarea>
                       </td>
                   </tr>


                   <tr>
                       <td class="info-table__title">
                           Provize:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   v-model="data.provision"
                                   @input="errors.provision = ''"
                                   :error-messages="makeError(errors.provision)"
                           >
                           </v-text-field>
                       </td>
                   </tr>

                   <tr>
                       <td class="info-table__title">
                           Publikováno:
                       </td>
                       <td class="info-table__value">
                           <v-checkbox
                                   class="input--small"
                                   outlined
                                   v-model="data.published"
                                   @input="errors.published = ''"
                                   :error-messages="makeError(errors.published)"
                           >
                           </v-checkbox>
                       </td>
                   </tr>
               </table>

           </v-layout>

           <h2>SEO</h2>
           <v-layout>

               <table class="info-table">

                   <tr>
                       <td class="info-table__title">
                           Titulek:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   @input="errors.seo_title = ''"
                                   v-model="data.seo_title"
                                   :error-messages="makeError(errors.seo_title)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Popis:
                       </td>
                       <td class="info-table__value">
                           <v-textarea
                                   class="input--larger"
                                   outlined
                                   @input="errors.seo_meta = ''"
                                   v-model="data.seo_meta"
                                   :error-messages="makeError(errors.seo_meta)"
                           >
                           </v-textarea>
                       </td>
                   </tr>
                   <!--<tr>
                       <td class="info-table__title">
                           Klíčová slova:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input&#45;&#45;larger"
                                   outlined
                                   @input="errors.seo_keywords = ''"
                                   v-model="data.seo_keywords"
                                   :error-messages="makeError(errors.seo_keywords)"
                           >
                           </v-text-field>
                       </td>
                   </tr>-->
               </table>
           </v-layout>
           <v-layout>
               <div class="controls-table">
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="addPublisher()"
                           v-if="type === 'add'
                    ">
                       Vytvořit
                   </v-btn>
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="editPublisher()"
                           v-else
                    >
                       Uložit
                   </v-btn>
                   <v-btn
                           color="error"
                           class="button--control"
                           @click="openDialogDelete()"
                           v-if="type !== 'add'"
                   >
                       Smazat
                   </v-btn>
               </div>
           </v-layout>

           <v-dialog v-model="dialogDelete" persistent>
               <v-card>
                   <v-card-title class="headline">Smazání vydavatele</v-card-title>
                   <v-card-text>
                       Opravdu si přejete smazat vydavatele <strong>{{data.name}}</strong>?
                   </v-card-text>
                   <v-card-actions>
                       <v-spacer></v-spacer>
                       <v-btn
                               color="empty"
                               class="button--dialog"
                               @click="closeDialogDelete()"
                       >
                           zrušit
                       </v-btn>
                       <v-btn
                               color="error"
                               class="button--dialog"
                               @click="deletePublisher()"
                       >
                           smazat
                       </v-btn>
                       <v-spacer></v-spacer>
                   </v-card-actions>
               </v-card>
           </v-dialog>
       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    export default {
        name: 'PublishersDetail',
        components: {
        },

        data() {
            return {
                imageUploaded: true,
                dialogDelete:false,
                type: 'add',
                loaded: false,
                data: {},
                errors: {}

            }
        },

        created() {
            const vm = this;
            this.$root.$on('upload-publisher-image', () => {
                vm.imageUploaded = false;
                vm.$forceUpdate();
            });

            this.$root.$on('uploaded-publisher-image', (response) => {
                vm.data.image = response.url;
                vm.data.image_id = response.id;
                vm.imageUploaded = true;
                vm.$forceUpdate();
            });

            this.fetchData();


        },
        computed: {
            ...mapState(['profile']),

        },
        mounted(){
        },
        methods: {
            selectCoverImage(){
                this.$root.$emit('select-publisher-image');
            },
            removeCoverImage(){
                this.data.image_id = null;
                this.data.image = null;
                this.$forceUpdate();
            },
            makeError(item){
                if(item === 'required'){
                    return 'Toto pole je povinné';
                }else if(item === 'already_used'){
                    return 'Je již používaný';
                }else if(item === 'not_valid'){
                    return 'Neplatný formát';
                }else if(item){
                    return 'Neznámá chyba';
                }else{
                    return '';
                }

            },
            openDialogDelete(){
                this.dialogDelete = true;
            },
            closeDialogDelete(){
                this.dialogDelete = false;
            },

            addPublisher(){
                this.loaded = false;
                const request = this.data;
                this.$axios.post('/admin/publishers/add', request).then((response) => {
                    this.$router.push({name: 'Publishers'});
                }).catch((e) => {
                    if(e.response.data.error_inputs){
                        this.errors = e.response.data.error_inputs
                    }
                    this.loaded = true;
                });
            },
            editPublisher(){
                this.loaded = false;
                const request = this.data;
                this.$axios.put('/admin/publishers/'+this.$route.params.id+'/edit', request).then((response) => {
                    this.$router.push({name: 'Publishers'});
                }).catch((e) => {
                    this.errors = e.response.data.error_inputs;
                    this.loaded = true;
                });
            },
            deletePublisher(){
                this.loaded = false;
                const request = this.data;
                this.$axios.delete('/admin/publishers/'+this.$route.params.id+'/delete', request).then((response) => {
                    this.$router.push({name: 'Publishers'});
                }).catch((e) => {
                    this.loaded = true;
                });
            },
            showBilling(){
                this.$router.push({ name: 'Billing',  query: { publisher: this.data.id }});

            },
            showSales(){
                this.$router.push({ name: 'Sales',  query: { publisher: this.data.id }});

            },
            importSales(){
                this.$root.$emit('import-excel');
                //this.$router.push({ name: 'SalesImport',  params: { id: this.data.id }});

            },
            fetchData(){

                if(this.$route.params.id === 'add'){
                    this.type = 'add';
                    this.data = {};
                    this.loaded = true;

                }else{
                    this.type = 'detail';
                    this.$axios.get('/admin/publishers/' + this.$route.params.id).then((response) => {
                        this.type = 'detail';
                        this.data = response.data.publisher;
                        this.loaded = true;
                    }).catch((e) => {
                        this.$router.push({name: 'Publishers'});
                        this.loaded = true;
                    });
                }
            },



        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
